<template>
  <section>
    <div class="warehouse-floor-plan">
      <el-form size="small" inline>
        <el-form-item label="仓库：">
          <el-select v-model="filters.wareid" collapse-tags>
            <el-option
              v-for="item in WareHouse"
              :label="item.warehouseName"
              :value="item.warehouseId"
              :key="item.warehouseId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属客户：">
          <el-select collapse-tags v-model="filters.orgid" clearable >
            <el-option
              v-for="item in organizationList"
              :label="item.customName"
              :value="item.organizationId"
              :key="item.organizationId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="总库位："
          ><span class="total-ware-space">{{ totalCount }}</span></el-form-item
        >
        <el-form-item label="未占用："
          ><span class="unoccupied-ware-space">{{
            totalCount - disCount
          }}</span></el-form-item
        >
        <el-form-item label="已占用："
          ><span class="occupied-ware-space">{{ disCount }}</span></el-form-item
        >
        <el-form-item label="库位总利用率："
          ><span class="ware-space-utilization"
            >{{ proportion }}%</span
          ></el-form-item
        >
      </el-form>
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

      <div class="floor-plan-container" v-loading="loading">
        <div class="floor-plan-main">
          <template v-if="floorPlanData.length">
            <div class="floor-plan-item floor-plan-item-number">
              <div v-for="(item, index) in floorPlanCount" :key="index">
                {{ index + 1 }}
              </div>
            </div>
            <div
              :class="`floor-plan-item 
                            floor-plan-item-${item.size || 'small'}
                            floor-plan-item-${item.type || 'normal'}`"
              v-for="(item, index) in floorPlanData"
              :key="index"
            >
              <div class="floor-plan-item-title">{{ item.name }}</div>
              <div class="floor-plan-item-content">
                <div
                  class="floor-plan-item-content-item"
                  v-for="(warehouse, index) in item.warehouseList"
                  :key="index"
                >
                  <div
                    :title="warehouseFloor.name"
                    v-for="(
                      warehouseFloor, floorIndex
                    ) in warehouse.warehouseFloor"
                    :key="floorIndex"
                    :class="`floor-plan-item-content-item-status
                                    ${
                                      warehouseFloor.selectClient
                                        ? 'lightBorder'
                                        : ''
                                    } 
                                    ${
                                      warehouseFloor.status === 1
                                        ? 'available'
                                        : 'occupied'
                                    }`"
                  >
                    {{ item.type ? warehouseFloor.name : "" }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <el-empty :image-size="200"></el-empty>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { getWarehouseFloorPlanList } from "../../api/api";
export default {
  components: { Toolbar },
  name: "WarehouseFloorPlan",
  data() {
    return {
      filters: {
        wareid: [],
      },
      buttonList: {},
      WareHouse: [],
      torganizationList: [],
      loading: false,
      floorPlanCount: 0,
      floorPlanData: [],
      totalCount: 0,
      disCount: 0,
      proportion: "",
    };
  },
  created() {
    this.getWarebaselist();
  },
  mounted() {
    this.getWarebaselist();
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    // console.log(111);
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.page = 1;
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.getWarelist.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    getWarebaselist() {
      let user = JSON.parse(window.localStorage.user);
      this.WareHouse = user.warehouseList;
      this.organizationList = user.organizationList;
    },

    //查询
    getWarelist() {
      let pata = {
        wareId: this.filters.wareid,
        orgID: this.filters.orgid,
      };
      if(this.filters.wareid==''){
        this.$message({
          message: "请先选择仓库！",
          type: "error",
        });

        return;
      }

      this.listLoading = true;
      getWarehouseFloorPlanList(pata).then((res) => {
        this.floorPlanData = res.data.response;
        this.floorPlanCount = Math.max(
          ...this.floorPlanData.map((item) => item.storageCount)
        );
        if (this.filters.orgid == undefined || this.filters.orgid== '') {
          //没选择客户，统计全部
          this.totalCount = this.floorPlanData.reduce((total, warehouse) => {
            const floorsCount = warehouse.warehouseList.reduce(
              (sum, warehouseItem) => {
                return sum + warehouseItem.warehouseFloor.length; // 计算每个仓库楼层的数量
              },
              0
            );
            return total + floorsCount; // 累加到总数
          }, 0);

          this.disCount = this.floorPlanData.reduce((total, warehouse) => {
            const floorsCount = warehouse.warehouseList.reduce(
              (sum, warehouseItem) => {
                return (
                  sum +
                  warehouseItem.warehouseFloor.filter(
                    (item) => item.status === 1
                  ).length
                ); // 计算每个仓库楼层的数量
              },
              0
            );
            return total + floorsCount; // 累加到总数
          }, 0);
        } //选择了客户则统计客户的
        else {
          this.totalCount = this.floorPlanData.reduce((total, warehouse) => {
            const floorsCount = warehouse.warehouseList.reduce(
              (sum, warehouseItem) => {
                return (
                  sum +
                  warehouseItem.warehouseFloor.filter(
                    (item) => item.selectClient === true
                  ).length
                ); // 计算每个仓库楼层的数量
              },
              0
            );
            return total + floorsCount; // 累加到总数
          }, 0);

          this.disCount = this.floorPlanData.reduce((total, warehouse) => {
            const floorsCount = warehouse.warehouseList.reduce(
              (sum, warehouseItem) => {
                return (
                  sum +
                  warehouseItem.warehouseFloor.filter(
                    (item) => item.status === 1 && item.selectClient === true
                  ).length
                ); // 计算每个仓库楼层的数量
              },
              0
            );
            return total + floorsCount; // 累加到总数
          }, 0);
        }
        this.proportion =
          this.totalCount > 0
            ? ((this.disCount / this.totalCount) * 100).toFixed(0)
            : 0;
        this.listLoading = false;
      });
    },
  },
};
</script>

<style>
.el-scrollbar__view {
  height: 100%;
}
</style>
<style lang="less" scoped>
.warehouse-floor-plan {
  height: 100%;

  .el-form--inline {
    .el-form-item {
      margin-right: 40px;
    }
  }

  .floor-plan-container {
    height: calc(100% - 162px);
  }
}

.total-ware-space,
.unoccupied-ware-space,
.ware-space-utilization,
.occupied-ware-space {
  background: #aaaaaa;
  font-size: 16px;
  width: 50px;
  text-align: center;
  display: inline-block;
  color: #fff;
}

.unoccupied-ware-space {
  background: #f2f2f2;
  color: #000;
  width: 50px;
}

.ware-space-utilization,
.occupied-ware-space {
  background: #70b603;
  width: 50px;
}

.floor-plan-main {
  padding: 20px;
  height: 100%;
  overflow: auto;
  border: 1px solid #ccc;
  display: flex;
  gap: 10px;

  .floor-plan-item {
    text-align: center;

    &-medium {
      margin-right: 30px;
    }

    &-large {
      margin-right: 60px;
    }
  }

  .floor-plan-item-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .floor-plan-item-content {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }

  .floor-plan-item-content-item {
    padding: 4px;
    border-radius: 5px;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    gap: 5px;

    &:empty {
      display: none;
    }
  }

  .floor-plan-item-content-item-status {
    width: 12px;
    height: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;

    &.available {
      background: #70b603;
      border-color: #70b603;
    }

    &.lightBorder {
      border-color: red;
    }
  }

  .floor-plan-item-groundArea .floor-plan-item-content-item-status {
    width: 120px;
    font-size: 12px;
    padding: 12px 0;
  }

  .floor-plan-item-reworkArea .floor-plan-item-content-item-status {
    width: 200px;
    font-size: 12px;
    padding: 12px 0;
  }

  .floor-plan-item-number {
    display: flex;
    flex-direction: column;
    padding-top: 32px;
    font-size: 14px;
    gap: 5px;
    line-height: 14px;
    margin-right: -4px;
  }
}
</style>